export function oportunList() {
    let hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ("msMaxTouchPoints" in navigator) {
        hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
        const mQ = matchMedia?.("(pointer:coarse)");
        if (mQ?.media === "(pointer:coarse)") {
            hasTouchScreen = !!mQ.matches;
        } else if ("orientation" in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        } else {
            // Only as a last resort, fall back to user agent sniffing
            const UA = navigator.userAgent;
            hasTouchScreen =
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        }
    }

    //Only run the animation if this is mobile/touchscreen and the screensize is correct.
    if( hasTouchScreen && window.innerWidth <= 768 ){
        const lists = document.querySelectorAll('oportun-list.list-small-badge');
        let currItem = 0;
        changeItems(lists, currItem);
        setInterval(()=> {
            currItem = changeItems(lists,currItem);
        }, 3000);
    }

    function changeItems(lists, currItem){
        lists.forEach( el => {
            el.querySelectorAll('oportun-list-item.small-badge:nth-child(' + currItem + ')').forEach( item => {
                item.classList.remove('show');
            })
        });
        currItem++;
        if(currItem > 3){
            currItem = 1;
        }
        lists.forEach( el => {
            el.querySelectorAll('oportun-list-item.small-badge:nth-child(' + currItem + ')').forEach( item => {
                item.classList.add('show');
            })
        });
        return currItem;
    }
}